import React, { Component } from "react";
import { Grid, Label, Icon, Button, Message } from "semantic-ui-react";
import request from "../../utils/request";
import { formatCurrency, addLeadingZeros } from "../../utils/constants";
import { AppContext } from "../../utils/context";

const headerLabelStyle = {
    "backgroundColor": "#235789",
    "color": "#fff"
}

class EventDetailsPageHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summary: {},
            countdown: {
                years: 0,
                days: 0,
                hours: 0,
                min: 0,
                sec: 0
            },
            event: props && props.event ? props.event : {},
            shopifySalesDeactivated: props.shopifySalesDeactivated
        };
    }

    componentDidMount = () => {
        // update every second
        this.interval = setInterval(() => {
            const date = this.calculateCountdown(this.props?.summary?.end_at);
            date ? this.setState({ countdown: date }) : clearInterval(this.interval);
        }, 1000);
    };

    componentWillUnmount = () => {
        clearInterval(this.interval);
    };

    componentDidUpdate = prevProps => {
        // Typical usage (don't forget to compare props):
        if (this.props.summary !== prevProps.summary) {
            this.setState({
            summary: this.props.summary,
            });
            clearInterval(this.interval);
            this.interval = setInterval(() => {
                const date = this.calculateCountdown(this.props.summary.end_at);
                date ? this.setState({ countdown: date }) : clearInterval(this.interval);
            }, 1000);
        }

        // Verify online sales state matches what's in memory (i.e state)
        if (this.props.shopifySalesDeactivated !== prevProps.shopifySalesDeactivated) {
            this.setState({ shopifySalesDeactivated: this.props.shopifySalesDeactivated });
        }
    };

    startStopShopify = async (isDeactivated) => { // start or stop bump-shopify sales
        this.setState({ shopifyBtnLoader: true }); // start shopify btn loading

        const { event } = this.state;
        let payload = {
            "eventId": event.id,
            "disable-utv": isDeactivated === 1 ? 0 : 1
        }
        await request
            .post(this, `api:/shopify/update-utv-status`, payload, false, 20000)
            .then(response => {
                if (response.success === false) {
                    alert(response.message);
                }
                this.setState({
                    event: {...event, shopify_seller_deactivated: response.shopify_seller_deactivated},
                    shopifySalesDeactivated: response.shopify_seller_deactivated
                }, () => this.stopShopifyBtnLoader());
            });
    };

    stopShopifyBtnLoader = () => { // stop shopify btn loading
        this.setState({ shopifyBtnLoader: false });
    }

    calculateCountdown(endDate) { // calculate countdown timer
      if (!endDate) return false;

      // use moment timezone library
      const moment = require('moment-timezone');

      const { time_zone } = this.context.config;

      // create a moment object for the event end time
      const endAt = moment.tz(endDate, time_zone);

      // convert to UTC
      const endAtUTC = endAt.utc();

      // current time in UTC
      const now = moment.utc()

      // take the difference
      let diff = endAtUTC.diff(now, "seconds");

      // Clear countdown when date is reached
      if (diff < 0) return false;

      const timeLeft = {
          years: 0,
          days: 0,
          hours: 0,
          min: 0,
          sec: 0
      };

      // Calculate time difference between now and the expected date
      if (diff >= (365.25 * 86400)) { // 365.25 * 24 * 60 * 60
          timeLeft.years = Math.floor(diff / (365.25 * 86400));
          diff -= timeLeft.years * (365.25 * 86400);
      }
      if (diff >= 86400) { // 24 * 60 * 60
          timeLeft.days = Math.floor(diff / 86400);
          diff -= timeLeft.days * 86400;
      }
      if (diff >= 3600) { // 60 * 60
          timeLeft.hours = Math.floor(diff / 3600);
          diff -= timeLeft.hours * 3600;
      }
      if (diff >= 60) {
          timeLeft.min = Math.floor(diff / 60);
          diff -= timeLeft.min * 60;
      }
      timeLeft.sec = diff;

      return timeLeft;
    }

    render() {
        const { countdown, summary, shopifySalesDeactivated, shopifyBtnLoader } = this.state;
        const { event, pause } = this.props;
        let totalSales = summary.sales ? summary.sales.total: 0;
        const { config } = this.context;

        if (event.is_import_raffle > 0) return false; // return null if import raffle
        return (
            <>
                {event.is_test > 0 && <Message
                    header='TEST EVENT'
                    content='This is a test event, it will not be listed in reports or winner lists.'
                    color='yellow'
                />}
                <Grid columns={"equal"}>
                    <Grid.Column>
                        <Label.Group size="large">
                        <Label style={headerLabelStyle}>
                            {totalSales ? (
                            formatCurrency(totalSales, config.language)
                            ) : (
                            <Icon loading name="spinner" />
                            )}
                            <Label.Detail>Sales</Label.Detail>
                        </Label>
                        <Label style={headerLabelStyle}>
                            {summary.jackpot ? (
                            formatCurrency(summary.jackpot.expenses, config.language)
                            ) : (
                            <Icon loading name="spinner" />
                            )}
                            <Label.Detail>Expenses</Label.Detail>
                        </Label>
                        {event.game_id !== 2 && event.game_id !== 4 && <Label style={headerLabelStyle}>
                            {summary.jackpot ? (
                            formatCurrency(summary.jackpot.jackpot, config.language, 2)
                            ) : (
                            <Icon loading name="spinner" />
                            )}
                            <Label.Detail>
                              {event.game_id === 3
                                ? this.context.language.en.find(item => item.varname === `game_${event.game_id}_jackpot_title_short`)?.value
                                : this.context.language.en.find(item => item.varname === `game_${event.game_id}_jackpot_title`)?.value
                              }
                            </Label.Detail>
                        </Label>}
                        <Label style={headerLabelStyle}>
                            {summary.jackpot ? (
                            event.game_id === 2 ? summary.jackpot.prize : formatCurrency(summary.jackpot.prize, config.language, 2)
                            ) : (
                            <Icon loading name="spinner" />
                            )}
                            <Label.Detail>
                              {this.context.language.en.find(item => item.varname === `game_${event.game_id}_prize_title`)?.value}
                            </Label.Detail>
                        </Label>
                        </Label.Group>
                    </Grid.Column>
                    <Grid.Column textAlign="right">
                        <Label.Group size="large">
                            {countdown.years > 0 && <Label style={headerLabelStyle}>
                                {addLeadingZeros(countdown.years)} <Label.Detail>D</Label.Detail>
                            </Label>}
                            <Label style={headerLabelStyle}>
                                {addLeadingZeros(countdown.days)} <Label.Detail>D</Label.Detail>
                            </Label>
                            <Label style={headerLabelStyle}>
                                {addLeadingZeros(countdown.hours)} <Label.Detail>H</Label.Detail>
                            </Label>
                            <Label style={headerLabelStyle}>
                                {addLeadingZeros(countdown.min)} <Label.Detail>M</Label.Detail>
                            </Label>
                            <Label style={headerLabelStyle}>
                                {addLeadingZeros(countdown.sec)} <Label.Detail>S</Label.Detail>
                            </Label>
                            {event.active_rsu_event > 0 && <Label style={headerLabelStyle}>
                                Active RSU Event
                            </Label>}
                            {+event.webenabled > 0 && (
                                <Button
                                    color="green"
                                    onClick={() => window.open(event.weburl)}
                                    compact
                                    icon="external"
                                    content="E-commerce Site"
                                />
                            )}
                            {summary.is_active === true && +event.webenabled === 1 && (
                                <Button
                                    color={+event.web_sales_paused === 1 ? "green" : "yellow"}
                                    onClick={pause}
                                    content={+event.web_sales_paused === 1 ? "Start E-commerce" : "Pause E-commerce"}
                                    icon={+event.web_sales_paused === 1 ? "play" : "pause"}
                                    compact
                                />
                            )}
                            {+event.shopify_enabled > 0 && event.shopify_storefront !== "" && (
                                <Button
                                    color="green"
                                    onClick={() => window.open(event.shopify_storefront)}
                                    compact
                                    icon="external"
                                    content="Shopify Storefront"
                                />
                            )}
                            {+event.shopify_enabled > 0 && event.shopify_storefront !== "" && (
                                <Button
                                    color={shopifySalesDeactivated === 1 ? "green" : "red"}
                                    onClick={() => this.startStopShopify(shopifySalesDeactivated)}
                                    compact
                                    loading={shopifyBtnLoader}
                                    disabled={shopifyBtnLoader}
                                    icon={shopifySalesDeactivated === 1 ? "play" : "stop"}
                                    content={shopifySalesDeactivated === 1 ? "Start Shopify Sales" : "Stop Shopify Sales"}
                                />
                            )}
                        </Label.Group>
                    </Grid.Column>
                </Grid>
            </>
        );
    }
}

EventDetailsPageHeader.contextType = AppContext;

export default EventDetailsPageHeader;
